<template>
  <div class="wrapper" v-if="ready">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Cuenta Corriente Materiales</h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <div class="p-2">
              <b-row align-v="center">
                <b-col>
                  <div>
                    <b-input-group size="sm" prepend="Exportadora/Cliente" class="mb-1">
                      <b-form-select
                        :options="clientOptions"
                        v-model="selectedClient"
                        :state="Boolean(selectedClient)"
                      ></b-form-select>
                    </b-input-group>
                    <b-input-group size="sm" prepend="Bodega">
                      <v-2-select
                        id="inline-form-custom-select-pref"
                        size="small"
                        ref="company_select"
                        :options="companyOptions"
                        v-model="selectedCompany"
                      />
                    </b-input-group>
                  </div>
                </b-col>
                <b-col class="text-right">
                  <span>
                    <download-csv />
                    <b-button class="ml-2" size="sm" @click.prevent="$bvModal.show('download-csv')">
                      Descargar Detalle
                    </b-button>
                    <download-pdf :docDefinition="content" />
                  </span>
                </b-col>
              </b-row>
            </div>
            <b-table :items="items" :fields="fields" />
            <div v-if="items.length == 0" class="text-center">
              <p>Nada que mostrar</p>
            </div>
            <div class="text-center pb-3" v-if="loading">
              <b-spinner class="float-center"></b-spinner>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DownloadPdf from "../reusable/DownloadPdf.vue";
import DownloadCsv from "./DownloadCsv.vue";
import V2Select from "../reusable/V2Select.vue";
export default {
  components: { V2Select, DownloadPdf, DownloadCsv },
  data() {
    return {
      loading: false,
      ready: false,
      companyOptions: [],
      clientOptions: [],
      selectedClient: null,
      selectedCompany: null,
      items: [],
      fields: [
        {
          key: "supply_code",
          label: "Código"
        },
        {
          key: "supply_name",
          label: "Descripción"
        },
        {
          key: "quantity",
          label: "Stock"
        }
      ]
    };
  },
  computed: {
    content() {
      if (this.selectedCompany) {
        const tableContent = [];
        const keys = this.fields.map((field) => field.key);
        tableContent.push(this.fields.map((field) => field.label));
        for (let item of this.items) {
          let row = [];
          for (let k of keys) {
            row.push(item[k]);
          }
          tableContent.push(row);
        }

        const docContent = {
          content: [
            { text: `Cuenta Corriente - ${this.selectedCompany.company_name}`, style: "header" },
            {
              style: "tableExample",
              table: {
                widths: ["*", 300, "*"],
                body: tableContent
              }
            }
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            tableExample: {
              margin: [0, 5, 0, 5]
            }
          }
        };
        return docContent;
      }
    }
  },
  watch: {
    selectedCompany(newVal) {
      if (newVal) {
        this.getCompanyAccount(newVal.id);
      }
    },
    selectedClient(newVal, oldVal) {
      this.selectedCompany = null;
      if (!oldVal) {
        this.getCompanies();
      }
    }
  },
  methods: {
    async getCompanyAccount(companyId) {
      try {
        const response = await this.$axios({
          method: "GET",
          url: `supplies/cuenta-corriente/?company_id=${companyId}&client_customer_id=${this.selectedClient}`,
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.loading = false;
        this.ready = true;
        for (let item of response.data) {
          if (parseInt(item.quantity) != 0) {
            this.items.push(item);
          }
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.ready = true;
      }
    },
    async getClients() {
      // Get client_customer_options
      this.loading = true;
      try {
        const response = await this.$axios({
          method: "GET",
          url: "production/get_customers/",
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.clientOptions = response.data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.ready = true;
      }
    },
    async getCompanies() {
      this.companyOptions = [];
      try {
        const response = await this.$axios({
          method: "GET",
          url: "api/v1/company/?no_page",
          headers: {
            "Content-Type": "application/json"
          }
        });
        for (let item of response.data) {
          const optionData = {
            text: item.company_number + " - " + item.company_name,
            value: item.id,
            ...item
          };
          this.companyOptions.push(optionData);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  async mounted() {
    this.getClients();
  }
};
</script>

<style scoped>
.extend-width {
  width: 300px;
}
</style>
